import { render, staticRenderFns } from "./FinancePacksRoiCompact.vue?vue&type=template&id=33d637b0&scoped=true&"
import script from "./FinancePacksRoiCompact.vue?vue&type=script&lang=js&"
export * from "./FinancePacksRoiCompact.vue?vue&type=script&lang=js&"
import style0 from "./FinancePacksRoiCompact.vue?vue&type=style&index=0&id=33d637b0&lang=scss&scoped=true&"
import style1 from "./FinancePacksRoiCompact.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d637b0",
  null
  
)

export default component.exports